<template>
  <div class="dbox-textarea-container notes">
    <textarea name="notes" id="notes" v-on:blur="onBlur" :value="notes"></textarea>
  </div>
</template>

<script>
export default {
  props: ["booking"],
  data: function() {
    return {
      editing: false
    };
  },
  computed: {
    notes: function() {
      return this.booking?.cdate?.notes || '';
    },
  },
  methods: {
    onBlur: function(event) {
      this.$emit("updated", {
        item: this.booking.cdate,
        name:'notes',
        value: event.target.value
      });
    }
  }
};
</script>

<style lang="scss" scoped>
</style>


